import { createSelector } from '@reduxjs/toolkit'

import { selectState } from '../selectState'

export const selectMultiExport = createSelector(selectState, (state) => state.multiExport)
